import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function updateSurvey(versionUuid, content) {
  const url = SURVEY_ENDPOINTS.UPDATE_CONTENT.replace(':versionUuid', versionUuid)
  const response = await apiClient('generic-survey').put(url, { content })
  if (response.data?.success === false) {
    throw new Error(response.data?.message || 'Failed to update survey')
  }
}
